var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavMatters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5.74362C23.1053 5.74362 24 6.74272 24 7.9721V22.2715C24 23.5031 23.1047 24.5 22 24.5H2C0.896 24.5 0 23.5031 0 22.2715V7.9721C0 6.74198 0.896 5.74362 2 5.74362H5.54133V1.98565C5.54133 1.16557 6.13867 0.5 6.87467 0.5H17.126C17.862 0.5 18.4593 1.16557 18.4593 1.98565V5.74362H22ZM8.208 3.47279V5.74585H15.7927V3.47279H8.208Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMatters);
export default __webpack_public_path__ + "static/media/nav_matters.862a7ec3da6879f0f1cc52b8f77260ad.svg";
export { ForwardRef as ReactComponent };